import { graphql } from "@acto/gql";
import { useMemo } from "react";
import { useQuery } from "urql";
import { DataAccessResult } from "@acto/taskpane/core/data-access/types";
import { CustomTalkingPoint } from "@acto/taskpane/core/domain";

const CustomTalkingPointsQuery = graphql(`
  query GetCustomTalkingPoints($filter: CustomTalkingPointFilter!) {
    customTalkingPoints(filter: $filter) {
      id
      __typename
      client {
        id
        __typename
        name
        externalReference
      }
      title
      userDetailsId
      createdAt
      completedAt
    }
  }
`);

interface CustomTalkingPointFilterOptions {
  customerId: string;
  completed?: boolean;
}

export function useCustomTalkingPoints({
  customerId,
  completed,
}: CustomTalkingPointFilterOptions): DataAccessResult<CustomTalkingPoint> {
  const filter = useMemo(
    () => ({
      clientId: customerId,
      completed,
    }),
    [customerId, completed],
  );

  const [result] = useQuery({
    query: CustomTalkingPointsQuery,
    variables: { filter },
    pause: !customerId,
  });

  const { data, fetching: isFetching, error } = result;
  const isPending = !data && isFetching;

  const customTalkingPoints = useMemo(() => data?.customTalkingPoints.map(CustomTalkingPoint.fromGraphql), [data]);

  return {
    data: customTalkingPoints,
    isFetching,
    isPending,
    error,
  };
}
